type ShoppingCartErrorCode = 'PASSWORD_REQUIRED';

class ShoppingCartError extends Error {
  code: ShoppingCartErrorCode;

  constructor(code: ShoppingCartErrorCode, message?: string) {
    super(message);
    this.code = code;
  }
}

export default ShoppingCartError;
